import React from 'react';
import styled from 'styled-components';
import { getTelegramUserName } from '../../utils/telegramUser';

const ACCENT = '#1E78FF';

const Wrapper = styled.div`
  width: 1200px;
  background: #151515;
  color: #ffffff;
  padding: 70px 80px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  font-family: 'Inter', sans-serif;
`;

const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
`;

const BrandLogo = styled.img`
  object-fit: contain;
`;

const Year = styled.span`
  font-family: Inter, sans-serif;
  color: #ffffff;
  font-size: 26px;
  font-weight: 600;
  letter-spacing: -0.02em;
`;

const Divider = styled.div`
  height: 1px;
  background: rgba(39, 39, 39, 1);
  flex-grow: 1;
`;

const ContentRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 24px;
  align-items: end;
`;

const Title = styled.h2`
  margin: 60px 0 96px;
  color: ${ACCENT};
  font-family: 'Manrope', sans-serif;
  font-size: 182px;
  font-weight: 500;
  line-height: 0.8;
  letter-spacing: -0.02em;
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Name = styled.div`
  margin: 0;
  font-family: 'Manrope', sans-serif;
  font-size: 80px;
  line-height: 0.8;
  letter-spacing: -0.02em;
  font-weight: 600;
`;

const Badge = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 60px;
  gap: 0;
  border: 4px solid ${ACCENT};
  border-radius: 14px;
  padding: 12px 16px;
  background: rgba(30, 120, 255, 0.06);
  width: fit-content;
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  font-size: 26px;
  line-height: 100%;
  letter-spacing: -0.02em;
`;

const BadgeDate = styled.span`
  color: #fff;
`;

const BadgeText = styled.span`
  color: ${ACCENT};
`;

const RightSeal = styled.div`
  position: relative;
  margin-top: auto;
  margin-left: auto;
`;

const SealLogo = styled.img`
  width: 314px;
  height: 314px;
  object-fit: contain;
`;

export interface CertificatePageProps {
  courseTitle?: string;
  dateISO?: string;
  status?: string;
}

export const CertificatePage: React.FC<CertificatePageProps> = ({
  courseTitle,
  dateISO,
  status,
}) => {
  const date = dateISO ? new Date(dateISO) : new Date();

  // Получаем локаль пользователя из браузера или используем английскую по умолчанию
  // Это обеспечивает корректное отображение даты в привычном для пользователя формате
  const userLocale = navigator.language || 'en-US';

  // Форматируем дату с использованием локали пользователя
  const formatted = date
    .toLocaleDateString(userLocale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
    .replace(/\./g, '/'); // Заменяем точки на слеши для единообразного отображения

  // Определяем имя для отображения: используем переданное имя или имя пользователя Telegram
  const displayName = getTelegramUserName();

  const year = date.getFullYear();

  return (
    <Wrapper id="certificate-print-root">
      <TopRow>
        <BrandLogo src="/assets/logo.svg" alt="STON" />
        <Divider />
        <Year>({year})</Year>
      </TopRow>
      <Title>DeFi {status}</Title>
      <ContentRow>
        <Info>
          <Name>{displayName}</Name>
          <Badge>
            <BadgeDate>{formatted}</BadgeDate>
            <BadgeText>{courseTitle}</BadgeText>
          </Badge>
        </Info>

        <RightSeal aria-hidden>
          <SealLogo src="/assets/stamp.svg" alt="logo" />
        </RightSeal>
      </ContentRow>
    </Wrapper>
  );
};

export default CertificatePage;
